// import { dateKsa } from "@/utils/global";
// import React, { useEffect, useState } from "react";
// import Compaign from "../../campaign";
// import { useRouter } from "next/router";

// const MegaSell = ({ children }) => {
//   const { current, counter_start, counter_end, open_at } = dateKsa();
//   const [state, setState] = useState({
//     showWebsite: current >= open_at || current <= counter_start,
//     showCounter: current >= counter_start && current <= counter_end,
//     hideCounter: current >= counter_end && current <= open_at,
//   });
//   const { locale, query } = useRouter();

//   useEffect(() => {
//     let interval;
//     const updateCountdown = () => {
//       const { current, counter_start, counter_end, open_at } = dateKsa();
//       const now = new Date(current).getTime();
//       let counterStart = new Date(counter_start).getTime();
//       let counterEnd = new Date(counter_end).getTime();
//       let openAt = new Date(open_at).getTime();

//       let difference = openAt - now;
//       const startCounterDiff = counterStart - now;
//       const endCounterDiff = counterEnd - now;
//       if (startCounterDiff <= 0) {
//         setState({
//           showWebsite: false,
//           showCounter: true,
//           hideCounter: false,
//         });
//       }
//       if (endCounterDiff <= 0) {
//         setState({
//           showWebsite: false,
//           showCounter: false,
//           hideCounter: true,
//         });
//       }
//       // console.log({
//       //   difference: difference / 1000,
//       //   startCounterDiff: startCounterDiff / 1000,
//       //   endCounterDiff: endCounterDiff / 1000,
//       // });
//       if (difference <= 0) {
//         clearInterval(interval);
//         setState({
//           showWebsite: true,
//           showCounter: false,
//           hideCounter: true,
//         });
//         return;
//       }
//     };

//     updateCountdown();
//     interval = setInterval(updateCountdown, 1000);

//     return () => clearInterval(interval);
//   }, [current, locale]);

//   if (query?.show === "mega25") return children;
//   if (state.showWebsite) return children;
//   if (state.hideCounter)
//     return <Compaign date={counter_end} locale={locale} counter={false} />;

//   if (true) {
//     return <Compaign date={counter_end} locale={locale} />;
//   }
// };

// export default MegaSell;

function MegaSell({children}) {
  return children
}

export default MegaSell
